const baseUrl = process.env.REACT_APP_BASE_URL;
export const getDealUrl = baseUrl + "feature_periods/";
